<template>
  <div>
    <app-card v-if="value && queryParams.FileType === 'excel'">
      <div class="text-center">
        กำลังสร้างเอกสาร จะดาวน์โหลดอัติโนมัติภายใน 15 วินาที หรือ
        <v-btn class="p-0 mx-1" outlined>ดาวน์โหลดอีกครั้ง</v-btn>
      </div>
      <div class="text-center">
        <v-progress-circular indeterminate color="success" />
      </div>
    </app-card>

    <app-card v-if="queryParams.FileType === 'pdf' && (src || value)">
      <div v-if="value">
        <div class="text-center">
          กำลังสร้างเอกสาร กรุณารอสักครู่
        </div>
        <div class="text-center">
          <v-progress-circular indeterminate color="success" />
        </div>
      </div>
      <div v-if="!value && src">
        <v-card class="my-2 pa-4 text-right" outlined>
          <v-row class="ma-0 pa-0">
            <v-col v-if="$vuetify.breakpoint.mdAndUp"></v-col>

            <v-col
              class="ma-0 px-0 py-1"
              :class="{ 'text-right': $vuetify.breakpoint.smAndDown }"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            >
              <v-btn
                class="mr-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="numPages = 1"
              >
                <v-icon>mdi-skip-backward</v-icon>
              </v-btn>

              <v-btn
                class="mr-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="numPages = numPages > 1 ? numPages - 1 : numPages"
              >
                <v-icon>mdi-skip-previous</v-icon>
              </v-btn>

              <span> Page: {{ currentPage }} / {{ pageCount }} </span>

              <v-btn
                class="ml-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="
                  numPages = numPages < pageCount ? numPages + 1 : numPages
                "
              >
                <v-icon>mdi-skip-next</v-icon>
              </v-btn>

              <v-btn
                class="ml-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="numPages = pageCount"
              >
                <v-icon>mdi-skip-forward</v-icon>
              </v-btn>
            </v-col>

            <v-col
              class="ma-0 pa-1"
              :class="{ 'text-right': $vuetify.breakpoint.smAndDown }"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            >
              <v-select
                v-model="pdfWidth"
                label="Zoom"
                :items="['50%', '75%', '100%', '150%', '200%', '300%']"
                :hide-details="true"
                outlined
                dense
              />
            </v-col>

            <v-col
              class="ma-0 pa-1"
              :class="{ 'text-right': $vuetify.breakpoint.smAndDown }"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            >
              <v-btn
                class="mx-1 pr-5"
                color="info"
                depressed
                large
                @click="onDownloadPDF"
              >
                <v-icon class="pr-1">mdi-download</v-icon>
                save
              </v-btn>
            </v-col>
          </v-row>
        </v-card>

        <v-card class="my-2 px-16 py-6" style="overflow-x:scroll" outlined>
          <pdf
            :src="src"
            :page="numPages"
            :style="`display: inline-block; width: ${pdfWidth}`"
            @num-pages="pageCount = $event"
            @page-loaded="currentPage = $event"
          ></pdf>
        </v-card>

        <v-card class="my-2 pa-4 text-right" outlined>
          <v-row class="ma-0 pa-0">
            <v-col v-if="$vuetify.breakpoint.mdAndUp"></v-col>

            <v-col
              class="ma-0 px-0 py-1"
              :class="{ 'text-right': $vuetify.breakpoint.smAndDown }"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            >
              <v-btn
                class="mr-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="numPages = 1"
              >
                <v-icon>mdi-skip-backward</v-icon>
              </v-btn>

              <v-btn
                class="mr-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="numPages = numPages > 1 ? numPages - 1 : numPages"
              >
                <v-icon>mdi-skip-previous</v-icon>
              </v-btn>

              <span> Page: {{ currentPage }} / {{ pageCount }} </span>

              <v-btn
                class="ml-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="
                  numPages = numPages < pageCount ? numPages + 1 : numPages
                "
              >
                <v-icon>mdi-skip-next</v-icon>
              </v-btn>

              <v-btn
                class="ml-1"
                color="grey darken-2"
                outlined
                fab
                small
                @click="numPages = pageCount"
              >
                <v-icon>mdi-skip-forward</v-icon>
              </v-btn>
            </v-col>

            <v-col
              class="ma-0 pa-1"
              :class="{ 'text-right': $vuetify.breakpoint.smAndDown }"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            >
              <v-select
                v-model="pdfWidth"
                label="Zoom"
                :items="['50%', '75%', '100%', '150%', '200%', '300%']"
                :hide-details="true"
                outlined
                dense
              />
            </v-col>

            <v-col
              class="ma-0 pa-1"
              :class="{ 'text-right': $vuetify.breakpoint.smAndDown }"
              :cols="$vuetify.breakpoint.smAndDown ? 12 : 'auto'"
            >
              <v-btn
                class="mx-1 pr-5"
                color="info"
                depressed
                large
                @click="onDownloadPDF"
              >
                <v-icon class="pr-1">mdi-download</v-icon>
                save
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </app-card>
  </div>
</template>

<script>
import pdf from 'vue-pdf'

export default {
  components: {
    pdf
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },

    queryParams: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentPage: 0,
      pageCount: 0,
      src: null,
      rawbinary: null,
      numPages: 1,
      pdfWidth: '100%'
    }
  },

  watch: {
    value() {
      this.onGenerateFile()
    }
  },

  methods: {
    async onGenerateFile() {
      if (this.value) {
        try {
          const body = this.queryParams
          await this.$store
            .dispatch(body.store, body)
            .then(res => {
              this.rawbinary = res.data
              if (body.FileType === 'excel') {
                var fileURL = window.URL.createObjectURL(
                  new Blob([this.rawbinary])
                )
                var fileLink = document.createElement('a')

                fileLink.href = fileURL
                fileLink.download = 'ReportEmpLeave_.xls'

                fileLink.click()
              } else if (body.FileType === 'pdf') {
                this.src = window.URL.createObjectURL(
                  new Blob([this.rawbinary])
                )
              } else {
                this.src = null
                this.rawbinary = null
              }
            })
            .then(() => {
              this.$emit('loadDone', false)
              this.$emit('input', false)
            })
        } catch (e) {
          console.log(e.response || e)
          this.$emit('loadDone', false)
          this.$emit('input', false)
        }
      }
    },

    onDownloadPDF() {
      var fileURL = window.URL.createObjectURL(new Blob([this.rawbinary]))
      var fileLink = document.createElement('a')

      fileLink.href = fileURL
      fileLink.download = 'RptEmpLeave_.pdf'

      fileLink.click()
    }
  }
}
</script>

<style lang="scss" scoped></style>
